var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57805 0.000579834C2.44958 0.000579834 3.1561 0.707097 3.1561 1.57863V21.0413H22.6187C23.4903 21.0413 24.1968 21.7478 24.1968 22.6193C24.1968 23.4908 23.4903 24.1974 22.6187 24.1974H1.57805C0.706517 24.1974 0 23.4908 0 22.6193V1.57863C0 0.707097 0.706517 0.000579834 1.57805 0.000579834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8534 0.616591C24.3903 1.32691 24.2838 2.36533 23.6155 2.93597L17.7195 7.97069C17.2365 8.38313 16.569 8.45075 16.0214 8.1427L12.3747 6.09125L7.18608 11.6143C6.58038 12.2591 5.59765 12.2598 4.99109 11.616C4.38452 10.9722 4.38382 9.92762 4.98952 9.28289L10.9887 2.89705C11.4704 2.38431 12.2104 2.26568 12.813 2.60463L16.5712 4.71883L21.6714 0.363688C22.3396 -0.206955 23.3166 -0.0937263 23.8534 0.616591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6722 6.46348C24.314 7.06737 24.3738 8.11001 23.8057 8.7923L17.9097 15.873C17.6313 16.2073 17.2374 16.4074 16.8178 16.4277C16.3982 16.4479 15.9888 16.2865 15.6831 15.9803L12.1199 12.4116L7.18608 17.6634C6.58039 18.3082 5.59765 18.3089 4.99109 17.6651C4.38453 17.0213 4.38382 15.9767 4.98952 15.332L10.9887 8.94607C11.582 8.31452 12.5402 8.29902 13.1514 8.91109L16.6465 12.4117L21.4812 6.60544C22.0494 5.92316 23.0303 5.8596 23.6722 6.46348Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7cdf70aa.svg";
export { ForwardRef as ReactComponent };